import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import FinancePage from '../licenseAnalyticsPage/financePage';
import ButtonDefault from '../../../components/ButtonDefault';
import eyeIconSrc from '../../../assets/icons/eye.svg';
import dashboardIconSrc from '../../../assets/icons/dashboard.svg';
import AntSwitch from './antSwitch';
import { ACTUALBUDGET, PAGE } from '../licenseAnalyticsSupport/typeInterfaces';
import OutlinedInput from '@mui/material/OutlinedInput';
import FormControl from '@mui/material/FormControl';
import FacilitiesPage from '../explorePageComponents/facilities/facilitiesComponent';
import TeamsPage from '../explorePageComponents/teams/teamsComponent';
import './index.css';
import PlayersPage from '../explorePageComponents/players/playersPage';
import { getClubValue, getSelectedPage } from '../licenseAnalyticsSupport/getLicenseAnalyticsActions';
import StaffPage from '../staff/staffPage';
import exportIcon from '../../../assets/icons/export.svg'
import {
  companyDetailsProps,
  accountingItemsProps,
  supportFundProps,
  generateXLSXFile,
} from '../../../common/exportFunctionality';
import { Facility, Staff, Player } from '../../../api/typesDc';
import { useQuery } from 'react-query';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { getClubDepartments } from '../../../api/club';
import { useTranslation } from 'react-i18next';
import { getLicenseCompanyDetails,
         getLicenseFacilityExplore,
         getLicenseFinance,
         getLicenseTeamsExplore,
         getPlayersCount,
         getPlayersExplore,
         getStaffResponse,
         getSupportFundExplore, } from '../../../api/licence';
import { getLeaguesHistory } from '../../../api/league';
import { faChartBar, faEye } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import { Box } from '@mui/material';
import { setActualOrBudgetValue, setPage, setSearchValue } from '../../../redux/reducers/licenceAnalytics';

const Label = styled.div`
  font-size: 14px;
  font-family: Montserrat;
  font-weight: bold;
  cursor: pointer;
`;
const Tab:any = styled.button`
  margin-top: 5px;
  font-size: 12px;
  font-family: Montserrat;
  font-weight: 600;
  cursor: pointer;
  color: black;
  background: border-box;
  border: 0;
  outline: 0;
  width: 100%;
  border-bottom: 0.25px solid #d3d3d3;
  transition: background-color 0.1s ease, transform 0.1s ease; /* Smooth transitions */

  ${({ selectedPage }:any) =>
    selectedPage &&
    `
    border-bottom: 2px solid black;
    background: rgba(0, 0, 0, 0.04);
    opacity: 1;
  `}
  &:hover {
    background-color: rgba(0, 0, 0, 0.03); /* Slightly shaded on hover */
    transform: scale(1.02); /* Slightly enlarges the element */
  }
`;
const ButtonGroup = styled.div`
  display: flex;
  flex: 1;
  height: 40px;
  min-width: 400px;
  margin: 0px 15px;
`;

// export const types = [PAGE.FINANCE];
export const types = [PAGE.FINANCE, PAGE.STAFF, PAGE.FACILITIES, PAGE.TEAMS, PAGE.PLAYERS];

const TabGroup = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [view, setView] = useState('Dashboard');
  const [search, setSearch] = useState('');
  const [isExporting, setIsExporting] = useState(false);
  const selectedPage = useSelector(getSelectedPage);
  const dispatch = useDispatch();
  const activeClubId = useSelector((state:any) => state?.clubDetails?.id);
  const isAdmin = useSelector((state:any) => state?.common?.isAdmin);
  const { licenceId } = useParams<{ licenceId: string }>();
  const [t] = useTranslation();
  const clubFilter = useSelector(getClubValue);

  // const types = [{t('FINANCE')}];

  const onActualBudgetChange = (e:any, value:any) => {
    if (value) {
      dispatch(setActualOrBudgetValue({ newValue: ACTUALBUDGET.BUDGET }));
    } else {
      dispatch(setActualOrBudgetValue({ newValue: ACTUALBUDGET.ACTUAL }));
    }
  };

  /**
   * This debounce only for event passing function
   * @param func
   * @param timeout
   * @returns
   */
  function debounce(func:any, timeout = 500) {
    let timer:any;
    return (event:any) => {
      const currentTarget = event.target;
      clearTimeout(timer);
      timer = setTimeout(() => {
        func(currentTarget);
      }, timeout);
    };
  }
  const handleSearch = (target:any) => {
    const searchValue = target.value;
    if (searchValue != null || searchValue != '') {
      dispatch(setSearchValue({ newValue: searchValue }));
    } else {
      dispatch(setSearchValue({ newValue: '' }));
    }
  };

  useEffect(() => {
    dispatch(setSearchValue({ newValue: '' }));
  }, [selectedPage, view]);

  type exportDataProps = {
    companyDetails: companyDetailsProps[];
    accountingItems: accountingItemsProps[];
    supportFund: supportFundProps[];
    staffs: Staff[];
    facilities: Facility[];
    teams: any[];
    playerDetails: Player[];
    departments: any[];
    leagueHistory: any[];
  };

  let exportData: exportDataProps = {
    companyDetails: [],
    accountingItems: [],
    supportFund: [],
    staffs: [],
    facilities: [],
    teams: [],
    playerDetails: [],
    departments: [],
    leagueHistory: [],
  };

  // const { data, isLoading } = useQuery(
  //   ['admin_licences_standards', { criteriaId: licenceId, clubId: activeClubId }],
  //   getLicenceReviewStandards,
  // );

  // const { data: departments = [] } = useQuery(
  //   ['departments', { clubId: clubFilter?.id || activeClubId }],
  //   getClubDepartments,
  //   {
  //     enabled: clubFilter || activeClubId,
  //   },
  // );
  // data && genUID(data, 'S');

  const handleExport = async () => {
    let clubId: any = null;
    if (isAdmin && clubFilter != undefined) {
      clubId = clubFilter?.id;
    } else if (!isAdmin) {
      clubId = activeClubId;
    }
    setIsExporting(true);
    const companyData = await getLicenseCompanyDetails({ clubId: clubId });
    const financeData = await getLicenseFinance({ clubId: clubId });
    const facilityData = await getLicenseFacilityExplore({ clubId: clubId });
    const teamsData = await getLicenseTeamsExplore({ clubId: clubId });
    const supportFundData = await getSupportFundExplore({ clubId: clubId });
    const staffData = await getStaffResponse({ clubId: clubId });
    const playersCountData = await getPlayersCount({ clubId: clubId });
    const departments = await getClubDepartments({ clubId: clubId, isExport: clubId == null });
    const playersData = await getPlayersExplore({ clubId: clubId });
    const leagueHistory = await getLeaguesHistory();

    if (
      companyData &&
      financeData &&
      facilityData &&
      teamsData &&
      supportFundData &&
      staffData &&
      playersCountData &&
      playersData &&
      departments &&
      leagueHistory
    ) {
      exportData = {
        ...exportData,
        companyDetails: companyData || [],
        accountingItems: financeData || [],
        supportFund: supportFundData || [],
        staffs: staffData || [],
        facilities: facilityData || [],
        teams: teamsData || [],
        playerDetails: playersData || [],
        departments: departments || [],
        leagueHistory,
      };

      generateXLSXFile({ data: exportData, isBulkExport: clubId == null, t: t });
      setIsExporting(false);
    }
  };

  // const handleIndividualExport = async (clubId) => {
  //   setIsExporting(true);
  //   const dc1 = await DC1Get({ clubId: clubId as number }).catch(() => setIsExporting(false));
  //   const dc2 = await DC2Get({ clubId: clubId as number }).catch(() => setIsExporting(false));
  //   const dc3 = await DC3Get({ clubId: clubId as number }).catch(() => setIsExporting(false));
  //   const dc4 = await DC4Get({ clubId: clubId as number }).catch(() => setIsExporting(false));
  //   const dc5 = await DC5Get({ clubId: clubId as number }).catch(() => setIsExporting(false));
  //   const dc6 = await DC6Get({ clubId: clubId as number }).catch(() => setIsExporting(false));
  //   const dc7 = await DC7Get({ clubId: clubId as number }).catch(() => setIsExporting(false));
  //   const dc8 = await DC8Get({ clubId: clubId as number }).catch(() => setIsExporting(false));

  //   if (dc1 && dc2 && dc3 && dc4 && dc5 && dc6 && dc7) {
  //     exportData = {
  //       ...exportData,
  //       companyDetails: [{ ...dc1, ...dc2 }] || [],
  //       accountingItems: dc3 || [],
  //       supportFund: dc4 || [],
  //       staffs: dc5 || [],
  //       facilities: dc6 || [],
  //       teams: dc7 || [],
  //       playerDetails: dc8 || [],
  //       departments: departments || [],
  //     };
  //     generateXLSXFile({ data: exportData, fileName: clubFilter?.name, t: t });
  //     setIsExporting(false);
  //   }
  // };
  const manageClick = (page:any) => {
      const tempView = page.includes('explore') ? 'Explore' : view;
      page.includes('/explore') && setView('Explore');
      switch (page) {
        case PAGE.FINANCE:
        case `/licenceanalytics/finance/dashboard`:
        case `/licenceanalytics/finance/explore`:
          dispatch(setPage({ page: PAGE.FINANCE }));
          tempView == 'Explore' ? navigate(`/licenceanalytics/finance/explore`) : navigate(`/licenceanalytics/finance/dashboard`);
          break;
        case PAGE.STAFF:
        case `/licenceanalytics/staff/dashboard`:
        case `/licenceanalytics/staff/explore`:
          dispatch(setPage({ page: PAGE.STAFF }));
          tempView == 'Explore' ? navigate(`/licenceanalytics/staff/explore`) : navigate(`/licenceanalytics/staff/dashboard`);
          break;
        case PAGE.FACILITIES:
        case `/licenceanalytics/facilities/dashboard`:
        case `/licenceanalytics/facilities/explore`:
          dispatch(setPage({ page: PAGE.FACILITIES }));
          tempView == 'Explore' ? navigate(`/licenceanalytics/facilities/explore`) : navigate(`/licenceanalytics/facilities/dashboard`);
          break;
        case PAGE.TEAMS:
        case `/licenceanalytics/teams/dashboard`:
        case `/licenceanalytics/teams/explore`:
          dispatch(setPage({ page: PAGE.TEAMS }));
          tempView == 'Explore' ? navigate(`/licenceanalytics/teams/explore`) : navigate(`/licenceanalytics/teams/dashboard`);
          break;
        case PAGE.PLAYERS:
        case `/licenceanalytics/players/dashboard`:
        case `/licenceanalytics/players/explore`:
          dispatch(setPage({ page: PAGE.PLAYERS }));
          tempView == 'Explore' ? navigate(`/licenceanalytics/players/explore`) : navigate(`/licenceanalytics/players/dashboard`);
          break;
      }
  }

  const manageViewClick = () => {
    view == 'Dashboard' ? setView('Explore') : setView('Dashboard');
    if (selectedPage == PAGE.FINANCE) {
    view == 'Dashboard' ? navigate(`/licenceanalytics/finance/explore`) : navigate(`/licenceanalytics/finance/dashboard`);
  } else if (selectedPage == PAGE.STAFF) {
    view == 'Dashboard' ? navigate(`/licenceanalytics/staff/explore`) : navigate(`/licenceanalytics/staff/dashboard`);
  } else if (selectedPage == PAGE.FACILITIES) {
    view == 'Dashboard' ? navigate(`/licenceanalytics/facilities/explore`) : navigate(`/licenceanalytics/facilities/dashboard`);
  } else if (selectedPage == PAGE.TEAMS) {
    view == 'Dashboard' ? navigate(`/licenceanalytics/teams/explore`) : navigate(`/licenceanalytics/teams/dashboard`);
  } else if (selectedPage == PAGE.PLAYERS) {
    view == 'Dashboard' ? navigate(`/licenceanalytics/players/explore`) : navigate(`/licenceanalytics/players/dashboard`);
  }
  }

  useEffect(() => {
    manageClick(location.pathname);
  }, [location])

  return (
    <div className="root">
      <div className="tabWrapper">
        <ButtonGroup>
          {types.map(type => (
            <Tab
              key={type}
              selectedPage={selectedPage === type}
              onClick={() => {manageClick(type)}}
            >
              {t(type).toUpperCase()}
            </Tab>
          ))}
        </ButtonGroup>
        <div style={{ display: 'flex', margin: '0px 20px', justifyContent: 'flex-end', gridGap: '20px' }}>
          {view == 'Explore' && (
            <FormControl sx={{ width: '100%', minWidth: '80px' }} size="small">
              <OutlinedInput
                placeholder={t('SEARCH')}
                onChange={e => {
                  const debounceHandleSearch = debounce(handleSearch);
                  debounceHandleSearch(e);
                }}
              />
            </FormControl>
          )}
          {selectedPage === PAGE.FINANCE && view != 'Explore' && (
            <div style={{ display: 'flex', alignItems: 'center', fontWeight: '500', marginRight: '10px' }}>
              <div style={{ display: 'flex', alignItems: 'center', paddingRight: '5px', paddingLeft: '5px' }}>
                {t('ACTUAL')}
              </div>
              <AntSwitch onChange={onActualBudgetChange} inputProps={{ 'aria-label': 'ant design' }} />
              <div style={{ display: 'flex', alignItems: 'center', paddingLeft: '5px' }}>{t('BUDGET')}</div>
            </div>
          )}
          {view !== 'Dashboard' && (
            <Box sx={{ width: '200px', margin: 'auto' }}>
              <ButtonDefault
                manageOnClick={() => {
                  handleExport();
                }}
                isLoading={isExporting}
                disabled={false}
                value={t('EXPORT_DATA')}
                icon={<FontAwesomeIcon className={'fs13'} icon={faDownload} />}
              />
            </Box>
          )}
          <Box sx={{ width: '170px', margin: 'auto' }}>
            <ButtonDefault
              manageOnClick={() => {manageViewClick()}}
              value={view == 'Dashboard' ? t('EXPLORE') : t('DASHBOARD')}
              icon={view == 'Dashboard' ? <FontAwesomeIcon className={'fs13'} icon={faEye} /> : <FontAwesomeIcon className={'fs13'} icon={faChartBar} />}
            />
          </Box>
        </div>
      </div>
      {selectedPage === PAGE.FINANCE && <FinancePage mode={view} />}
      {selectedPage === PAGE.STAFF && <StaffPage mode={view} />}
      {selectedPage === PAGE.FACILITIES && <FacilitiesPage mode={view} />}
      {selectedPage === PAGE.TEAMS && <TeamsPage mode={view} />}
      {selectedPage === PAGE.PLAYERS && <PlayersPage mode={view} />}
    </div>
  );
};

export default TabGroup;
